<app-pageheader [Parent]="this">
  <add-button AddRoute="/valet/types/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="valet/types/searches"
  [AllowEdit]="true" EditUrl="/valet/types/:id" [HighLightCondition]="['Open']" [UseQueryParamStates]="true">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>